module.exports = function() {
	return new Worker(__webpack_public_path__ + "271632a584b9e2ea33b5.fertilizers.wrkr.js");
};